import React from 'react'
import { Divider } from 'antd'
import { useTranslation } from 'next-i18next'
import { BigOrderItem, Order } from 'src/core/models'
import OrderProjectDetailList from './OrderProjectDetailList/OrderProjectDetailList'
import {
  OrderProjectDetailLabel,
  oldOrderDetailsLabels,
  orderDetailsInCustomerCurrency,
  orderDetailsInCustomerCurrencyV2,
  orderDetailsInProjectCurrency
} from './order-project.helpers'

interface OrderProjectDetailsProps {
  order: Order
  orderItem: BigOrderItem
}

const OrderProjectDetails: React.FC<OrderProjectDetailsProps> = ({ order, orderItem }) => {
  const { t } = useTranslation()
  const code = orderItem.project_currency_token
  const divider = orderItem.is_free_donation ? '' : '/'


  const customerLabels = orderDetailsInCustomerCurrency(t, orderItem, code, divider)
  const showCustomer = Boolean(orderItem.user_unit_price && orderItem.user_total_amount)

  let labels: OrderProjectDetailLabel[] // Adjust the type according to the actual return type of your helper functions
  let title: string

  if (orderItem.project_currency_code) {
    if (orderItem.customerInvoice) {
      labels = orderDetailsInCustomerCurrencyV2(t, orderItem, order, code, divider)
      title = t('Transactions.ProjectDetailsCustomerInvoice')
    } else {
      labels = orderDetailsInProjectCurrency(t, orderItem, order, code, divider)
      title = t('Transactions.ProjectDetails')
    }
  } else {
    labels = oldOrderDetailsLabels(t, orderItem, order, code, divider)
    title = t('Projects.Details.Title')
  }

  return <>
    <OrderProjectDetailList
      title={title}
      labels={labels}
    />
    {showCustomer && <>
      <Divider />
      <OrderProjectDetailList
        title={t('Transactions.ProjectCurrency')}
        labels={customerLabels}
      />
    </>}
  </>
}

export default OrderProjectDetails
